import { Avatar, Box, Stack, Typography } from "@mui/material";
import SectionHeading from "../MostPopularJob/SectionHeading";
import SectionsSecondaryHeading from "../MostPopularJob/SectionsSecondaryHeading";
import BlogAndNewsCard from "./BlogAndNewsCard";
import SectionHeadingButton from "../WeHelpJobSeekers/SectionHeadingButton";
const blogCards = [1, 2, 3];
function BlogAndNewsSection() {
  return (
    <Stack
      direction="column"
      sx={{ justifyContent: "center", alignItems: "center" }}
    >
      <SectionHeading>Blog & News</SectionHeading>
      <SectionsSecondaryHeading py="12px">
        Expert advice and career resources all in the Pitchers Blog.
      </SectionsSecondaryHeading>
      <Stack
        direction="row"
        id="blog-and-news-cards"
        sx={{ gap: "18px", py: "24px" }}
      >
        {blogCards.map((card) => (
          <BlogAndNewsCard />
        ))}
      </Stack>
      <SectionHeadingButton>View all Articles</SectionHeadingButton>
    </Stack>
  );
}

export default BlogAndNewsSection;
